import React, { Component } from 'react';

class aboutus extends Component {
    render() {
        return (

            <div>
                <label><h3>PASSION FRAMEWORK</h3></label>
            <div>    
                <p> 
A 2-decade old research initiated as PASSION, a concept to help the jobless community and build entrepreneurship ecosystem. It evolved as a framework as part of a PhD Thesis by Dr. Prakash Sharma, who has 30+ years of experience in the IT industry. The framework has 7 Dimension and 28 process areas, and we actively engage senior thought leaders, technical leads, academicians to focus on practical research/pain points within their existing companies or experiences and build entrepreneurship-focused research papers/articles in any of chosen process areas. There are opportunities to cofound companies, initiate startup at absolute low cost and contribute to society. Our blog which explains entrepreneurship using stories and poems has over 98 country viewership. Our virtual incubation PCOMBINATOR has been benchmarked as one of the top 10% accelerator program with reference to competency development.
Linkedin  https://www.linkedin.com/in/dr-prakash-sharma-330743a3/?originalSubdomain=in
Look forward to active participation.</p>
</div>
            </div>
        );
    }
}

export default aboutus;



/** WEBPACK FOOTER **
 ** ./src/containers/aboutus.js
 **/